import { ApolloError, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import ms from 'ms.macro'
import { useMemo } from 'react'

import { UserInfoQuery } from './__generated__/types-and-hooks'
import { apolloCompetitionClient } from './apollo'

const query = gql`
  query UserInfo($user: ID!) {
    user(id: $user) {
      referrer {
        id
        refCode
      }
      refCode
      refsCount
      multiplier
      multiplierStart
      multiplierEnd
      clearVolume
      bonusVolume
      refsVolume
      totalVolume
      taskIds
    }
  }
`

export interface IUserInfo {
  error?: ApolloError
  isLoading: boolean
  data: UserInfoQuery
}
export default function useUserInfo(account?: string): IUserInfo {
  const {
    data,
    loading: isLoading,
    error,
  } = useQuery(query, {
    variables: {
      user: account?.toLowerCase(),
    },
    client: apolloCompetitionClient,
    pollInterval: ms`15s`,
  })

  return useMemo(
    () => ({
      error,
      isLoading,
      data,
    }),
    [data, error, isLoading]
  )
}
